module.exports = __webpack_public_path__ + "img/img_analyist_dog.aaa7988d.png";